var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.21 15.55a3.35 3.35 0 1 0 0-6.7 3.35 3.35 0 0 0 0 6.7M11.21 22c2.298 0 4.16-1.177 4.16-2.63s-1.862-2.63-4.16-2.63-4.16 1.178-4.16 2.63c0 1.453 1.863 2.63 4.16 2.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.51 7.64a2.82 2.82 0 1 0 0-5.64 2.82 2.82 0 0 0 0 5.64M5.88 7.64a2.82 2.82 0 1 0 0-5.64 2.82 2.82 0 0 0 0 5.64M16.35 9.83c-.32 0-.63 0-.94.05a4.68 4.68 0 0 1-.41 5.27q.673.134 1.36.14c2.54 0 4.59-1.23 4.59-2.73s-2.06-2.73-4.6-2.73",
    opacity: 0.3
  })));
};
export default SvgPeople;